var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',[(!_vm.canViewAllConventions && !_vm.isMyConvention)?_c('convention-obligations-select',{attrs:{"user":_vm.user,"convention":_vm.convention}}):_vm._e(),(_vm.canViewAllConventions || _vm.isMyConvention)?_c('convention-obligations',{attrs:{"convention":_vm.convention}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }